import type { ReactNode } from 'react';

import { cn, Icon, type IconName } from '@/design-system';

/**
 * One or two plain sentences and at most one action. No illustration; an optional muted concept glyph (CLAUDE.md §23
 * allows icons in empty states) names what is empty.
 */
export function EmptyState({ title, body, action, icon, className }: { title: ReactNode; body?: ReactNode; action?: ReactNode; icon?: IconName; className?: string }) {
  return (
    <div className={cn('flex items-start gap-3 py-6', className)}>
      {icon ? <Icon name={icon} size="lg" tone="muted" className="mt-px" /> : null}
      <div className="flex min-w-0 flex-col items-start gap-1">
        <p className="text-body font-medium text-ink">{title}</p>
        {body ? <p className="max-w-prose text-body text-ink-secondary">{body}</p> : null}
        {action ? <div className="pt-2">{action}</div> : null}
      </div>
    </div>
  );
}
